export default __webpack_public_path__ + "static/media/a012-market-3.e8a064d5.svg";